import {
  Component,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
  OnInit,
  Renderer2,
  HostListener,
} from '@angular/core';
import { MenuService } from '../../services/menu/menu.service';
import { DialogService } from '../../services/dialog/dialog.service';
import { BusquedaMenuComponent } from './busqueda-menu/busqueda-menu.component';
import { AgenteService } from '../../services/agente/agente.service';
import { MatSnackBar } from '@angular/material';
import { MensajeSnackBarService } from '../../services/mensaje-snack-bar/mensaje-snack-bar.service';
import { MenuItem } from '../../models/menu/menu-item.class';
import { Delegado } from '../../models/agente/delegado.class';
import { Auxiliar } from '../../models/agente/auxiliar.class';
import { Asesor } from '../../models/agente/asesor.class';
import { RedireccionService } from '../../services/redireccion/redireccion.service';
import { UtilService } from '../../services/util/util.service';
import { MasterMenuComponent } from './master-menu/master-menu.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent extends MasterMenuComponent implements OnInit {
  private ListCompletaMenu: MenuItem[];
  public ListAMostrarMenu: MenuItem[];
  private ListPadresMenu: MenuItem[] = [];
  public padreActual: MenuItem = null;
  public busqueda = false;

  @ViewChild('busquedaOpciones') busquedaMenuComponent: BusquedaMenuComponent;

  @ViewChild('btnHamburguesa')
  btnHamburguesa: any;

  constructor(
    private menuService: MenuService,
    private chRef: ChangeDetectorRef,
    private agenteService: AgenteService,
    public snackBar: MatSnackBar,
    public mensajeSnackBarService: MensajeSnackBarService,
    public redireccionService: RedireccionService,
    public dialogService: DialogService,
    public utilService: UtilService,
    public renderer: Renderer2
  ) {
    super(
      redireccionService,
      dialogService,
      mensajeSnackBarService,
      utilService
    );
  }

  ngOnInit(): void {
    this.busquedaMenuComponent.trigger.closePanel();
    this.menuService.getListMenu().subscribe((menu: MenuItem[]) => {
      this.ListCompletaMenu = menu;
      this.inciarMenu();
    });
  }

  atajoBtnMenu($event: any) {
    this.btnHamburguesa.nativeElement.click();
  }

  @HostListener('document:keydown.control.b')
  clickBtnMenu($event: any) {
    if (!this.agenteService.habilitarOpcionesAgente()) {
      $event.stopPropagation();
      this.mensajeSnackBarService.mostrarMensaje(
        this.agenteService.getAgente().getRestriccionSeleccionAgente()
      );
    } else {
      this.inciarMenu();
    }
  }

  habilitarMenu(): boolean {
    return this.agenteService.habilitarOpcionesAgente();
  }

  validarMenuAuxiliar(agenteLogin: Asesor | Auxiliar | Delegado) {
    return agenteLogin instanceof Auxiliar;
  }

  inciarMenu() {
    this.ListAMostrarMenu = this.ListCompletaMenu;
    this.ListPadresMenu = [];
    this.padreActual = null;
  }

  async ejecutarAccionMenu(opcionMenu: MenuItem) {
    this.inciarMenu();
    this.ejecutarOpcionSeleccionada(opcionMenu);
  }

  seleccionOpcion(opcionMenu: MenuItem, $event: any) {
    // Validamos si la opccion que seleccionamos tiene mas niveles
    if (
      opcionMenu.children !== null &&
      opcionMenu.children !== undefined &&
      opcionMenu.children.length > 0
    ) {
      // agregamos la opcion en la lista de padres
      this.ListPadresMenu.push(opcionMenu);
      this.padreActual = opcionMenu;
      this.ListAMostrarMenu = [];
      this.chRef.detectChanges();
      // y a la lista para pintar le indicamos que van hacer los hijos de la opcion seleccionada
      this.ListAMostrarMenu = opcionMenu.children;
      // paramos el evento de cerrar el menu
      this.detenerEvento($event);
    } else {
      this.ejecutarAccionMenu(opcionMenu);
    }
  }

  detenerEvento($event: any) {
    $event.stopPropagation();
  }

  regresar(opcionMenu: MenuItem, $event) {
    $event.stopPropagation();
    // validamos si la lista contiene algun padre mostrandose
    if (this.ListPadresMenu !== null && this.ListPadresMenu.length > 0) {
      this.ListPadresMenu.pop();
    }
    if (this.ListPadresMenu.length === 0) {
      this.ListAMostrarMenu = this.ListCompletaMenu;
    } else {
      // mostramos la informacion del padre siguiente
      this.ListAMostrarMenu =
        this.ListPadresMenu[this.ListPadresMenu.length - 1].children;
    }

    this.getPadreActual();
  }

  getPadreActual() {
    let padreActual: MenuItem = null;
    if (this.ListPadresMenu !== null && this.ListPadresMenu.length > 0) {
      padreActual = this.ListPadresMenu[this.ListPadresMenu.length - 1];
    }
    this.padreActual = padreActual;
  }

  verRegresar(): boolean {
    let ver = false;
    if (this.padreActual !== null) {
      ver = true;
    }

    return ver;
  }

  verMasOpciones(opcionMenu: MenuItem): boolean {
    let tiene = false;
    if (
      opcionMenu.children !== undefined &&
      opcionMenu.children !== null &&
      opcionMenu.children.length > 0
    ) {
      tiene = true;
    }

    return tiene;
  }

  verImagen(opcionMenu: MenuItem): boolean {
    let ver = false;
    if (opcionMenu.imageLocal !== null && opcionMenu.imageLocal !== undefined) {
      ver = true;
    }

    return ver;
  }

  obtenerClass(opcionMenu: MenuItem) {
    const classStyle = {};
    classStyle['dropdown-item'] = true;

    if (
      opcionMenu !== undefined &&
      opcionMenu !== null &&
      opcionMenu.styleClass !== undefined &&
      opcionMenu.styleClass !== null
    ) {
      classStyle[opcionMenu.styleClass.toString()] = true;
    }

    return classStyle;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/menu/menu.component.ts